<template>
  <div style="padding-bottom: 40px;position:relative;height: 100%;" ref="drawer">
    <a-steps :current="current" style="width: 60%;margin: 0 auto 30px;">
      <a-step v-for="el in stepList" :key="el.title" :title="el.title" :description="el.description" />
    </a-steps>
    <EstimateList style="height: calc(100% - 85px)" ref="estimateList" v-if="current === 0" :drwaerObj='drwaerObj' />
    <AssessmentList style="height: calc(100% - 85px)" v-if="current === 1" :drwaerObj='drwaerObj'/>
    <div style="position: absolute;bottom: 0;left: 0;right: 0;height: 40px;">
      <a-button :disabled='exportFlag' v-if="current === 1" @click="exportTable" style="float: left;margin-left: 20px">
        <a-spin v-if="exportFlag">
          <a-icon slot="indicator" type="loading" style="font-size: 16px" spin />
        </a-spin>
        <span v-if="!exportFlag">导出</span>
      </a-button>
      <a-button v-if="current === 0" type="primary" @click="assessment(1)" style="float: right;margin-right: 20px">
        评估
      </a-button>
      <a-button v-if="current === 1" type="primary" @click="assessment(0)" style="float: right;margin-right: 20px">
        返回
      </a-button>
    </div>
  </div>
</template>
<script>
import EstimateList from './EstimateList.vue'
import AssessmentList from './AssessmentList.vue'
import axios from 'axios'
import { baseUrl } from '@/Utils/url.js'
export default {
  components:{EstimateList,AssessmentList},
  props:{
    drwaerObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data(){
    return {
      stepList:[
        {title: '配方管理',description: '管理量表中的配方'},
        {title: '原料统计',description: '预估原料用量统计'}
      ],
      current: 0,
      exportFlag: false
    }
  },
  methods: {
    assessment(num){
      this.current = num
    },
    exportTable(){
      this.exportFlag = true
      let instance = axios.create({
        timeout: 100000,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          responseType: 'arraybuffer'
        },
        responseType: 'arraybuffer'
      })
      instance.interceptors.request.use(
        config => {
          let token = window.localStorage.getItem('accessToken')
          if (token) config.headers.common['iot-Auth'] = 'bearer ' + token
          return config
        },
        err => {
          return Promise.reject(err)
        }
      )
      // if (process.env.NODE_ENV === 'production') {
        instance.defaults.baseURL = baseUrl
      // }
      // progressDownLoad({url:'/nhf-app/productiondetail/formula/rawStatisticsDownload', data: {forecastId:this.drwaerObj.id}})
      // .catch(e => {
      //   this.$message.error(e.message)
      // })
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      instance({method:'get',url:'/nhf-app/productiondetail/formula/rawStatisticsDownload',  params: {forecastId:this.drwaerObj.id,aliasFlag} ,onDownloadProgress:() => {
        this.exportFlag = false
      }}).then(response => {
        const f = response.headers['Content-Disposition'] || response.headers['content-disposition']
        const type = response.headers['Content-Type'] || response.headers['content-type']
        const fileName = f.match(/filename=(.*)/)[1]
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type
        })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(fileName))
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob)
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', decodeURI(fileName))
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          // 挂载a标签
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL)
        }
      })
    }
  }
}
</script>
<style>
.ant-drawer-body{
  height: calc(100% - 55px);
}
</style>